module.exports = __webpack_public_path__ + "media/images/user/lp/mv/calling-99ab4e4bf713579fbb43cfb6fd6da0cf.png";